import React, { createContext, useEffect, useState } from 'react';
import api from '../services/api';

export const SettingsContext = createContext();

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    let mounted = true;

    // Fetch general settings (fallback local)
    const fetchSettings = api.get('/api/settings').then(res => (res.data?.data || res.data)).catch(() => ({
      platformName: 'Timte 2026',
      footerText: '© 2026 Timte. All rights reserved.',
      logoUrl: '',
      supportEmail: '',
    }));

    // Fetch CMS items to extract loader config
    const fetchCms = api.get('/api/cms').then(res => (res.data || [])).catch(() => []);

    Promise.all([fetchSettings, fetchCms]).then(([s, cms]) => {
      if (!mounted) return;
      const settingsObj = { ...(s || {}) };
      const loaderItem = (cms || []).find(i => i.type === 'loader');
      if (loaderItem && loaderItem.contentJSON) {
        settingsObj.loader = loaderItem.contentJSON;
      }
      const footerItem = (cms || []).find(i => i.type === 'footer');
      if (footerItem && footerItem.contentJSON) {
        settingsObj.footer = footerItem.contentJSON;
      }
      if (mounted) setSettings(settingsObj);
    }).catch(() => {
      if (mounted) setSettings({ platformName: 'Timte 2026' });
    });

    return () => { mounted = false; };
  }, []);

  return (
    <SettingsContext.Provider value={settings}>
      {children}
    </SettingsContext.Provider>
  );
}